module.exports = __webpack_public_path__ + "static/media/logo.b8c8cfef.png";


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/Topbar/atoms/Logo/logo.png
// module id = 206
// module chunks = 101